import React, {Component} from 'react';
import {Button} from "reactstrap";
import {Image} from '../common/Image';

class SquareButton extends Component {

	constructor(props) {
		super(props);

		this.state = {};
	}

	render() {

		let cloneProps = Object.assign({}, this.props);
		let isCreditSufficient = true;
		if(this.props && this.props.isCreditSufficient!=undefined){
			isCreditSufficient = this.props.isCreditSufficient
		}
		if (cloneProps.title) {
			cloneProps.toggle = "tooltip";
			cloneProps.placement = "top";
			cloneProps.rel = "tooltip";
		}

		return (
			<div>
				<Button
					{...cloneProps}
					disabled={
						!isCreditSufficient ||
						(this.props.selection &&
							(this.props.selection.length === 0 || this.props.btnDisabled))
					}
					style={this.props.style && this.props.style}
					className={
						this.props.icon ? 'mini-button ' + this.props.icon : 'mini-button'
					}
					title={this.props.title}>
					{this.props.cssIconClass ? (
						<span
							className={this.props.cssIconClass}
							style={{
								display: 'inline-block',
								width: '21px',
								height: '21px',
								backgroundSize: 'contain',
								backgroundRepeat: 'no-repeat',
								backgroundPosition: 'center',
								...this.props.imgStyle,
							}}
						/>
					) : (
						this.props.img && (
							<Image
								className='simple-text logo-mini'
								style={this.props.imgStyle ? this.props.imgStyle : { width: '17px' }}
								src={process.env.REACT_APP_CONTEXT_NAME + '/image/' + this.props.img}
							/>
						)
					)}
					{this.props.fontAwesomeClass && <i className={this.props.fontAwesomeClass} />}
				</Button>
			</div>

		)
	}
}

export default SquareButton;